import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import _ from 'lodash'
import { FormattedMessage } from 'react-intl'
import { PieChart } from 'gnos-charts'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

export default class Tab extends Component {
    static propTypes = {
        active: PropTypes.bool.isRequired,
        chartData: PropTypes.array.isRequired,
        label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        onClickHandler: PropTypes.func,
        type: PropTypes.string.isRequired,
    }

    static defaultProps = {
        onClickHandler: () => {},
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.active !== nextProps.active) return true
        if (this.props.label !== nextProps.label) return true
        if (this.props.type !== nextProps.type) return true
        if (!_.isEqual(this.props.chartData, nextProps.chartData)) return true

        return false
    }

    onClickHandler = (_e) => {
        const { onClickHandler, type } = this.props
        _e.stopPropagation()

        onClickHandler(type)
    }

    render() {
        const { active, chartData, label, type } = this.props

        return (
            <div className={cx('block-negative-events-tab', active && 'active')} onClick={this.onClickHandler}>
                <div className={'text'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.${type}`} />
                </div>
                <div className={'chart'}>
                    <div className={'chart-wrap'}>
                        <PieChart
                            style={{ position: 'absolute', top: 0, width: '100%', height: '100%' }}
                            dataProvider={chartData}
                            label={label}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
